import React from 'react'
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import "./footer.scss"

const Footer = () => {
  return (
    <div className='text-center mt-5 footer'>
    <div className='social d-flex align-items-center justify-content-center gap-4 mb-3'>
        <div className='icon'><FaFacebookF/></div>
        <div className='icon'><FaTwitter /></div>
        <div className='icon'><FaInstagram/></div>
    </div>
    <small>&copy; Copyright Ping. All rights reserved.</small>  
    </div>
  )
}

export default Footer
